let tabs = document.querySelectorAll('.header-tabs');

tabs.forEach(function(tab){
  let tabTitles = tab.querySelectorAll('button');
  tabTitles.forEach(function(tabTitle){
    tabTitle.addEventListener('click', function(){
      removeAllActiveTabs();
      tabTitle.classList.add('active');
      let tabContent = tab.querySelector('.header-tab-content[data-tab-title="'+tabTitle.dataset.tabTitle+'"]'); 
      if (tabContent){
        tabContent.classList.add('active');
      }
    });
  })
})

function removeAllActiveTabs(){
  tabs.forEach(function(tab){
    let activeTab = tab.querySelector('button.active');
    if (activeTab){
      activeTab.classList.remove('active');
    }
    
    let activeTabContent = tab.querySelector('.header-tab-content.active');
    if (activeTabContent){
      activeTabContent.classList.remove('active');
    }

  });
}